import template from './adpTimelineContextualMenu.html';
import controller from './adpTimelineContextualMenu.controller';
import './adpTimelineContextualMenu.less';

let adpTimelineContextualMenuComponent = {
  restrict: 'E',
  bindings: {},
  transclude: true,
  template,
  controller
};

export default adpTimelineContextualMenuComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpTimelineContextualMenu/adpTimelineContextualMenu.component.js